<template>
    <div style="width:100%;" :style="{height:innerHeight+'px'}">
        <ExamHeader/>
        <div class="content" :style="{height:`${innerHeight- 56}px`}">
            <LeftPanel/>
            <RightPanel/>
        </div>
        <div style="display: none;" id="videoContainer"></div> 
    </div>
</template>
<script>
import { mapState } from 'vuex'
import ExamHeader from './components/header'
import LeftPanel from './components/leftPanel'
import RightPanel from './components/rightPanel'
import { AliRTSPusher } from 'aliyun-rts-pusher';

export default {
    components:{
        ExamHeader,
        LeftPanel,
        RightPanel,
    },
    computed:mapState([
        'examType',
    ]),
    data() {
        return {
            innerHeight:'',
            pushClient: '',
            screenVideoStream: '',
            avatarVideoStream: '',
            count: 0,
            inteval: '',
            resultCount: '',
            hasUpload: 0,
            videoEle: '',
        }
    },
    async mounted(){
        if(this.examType === 0){
            return false;
        }
        const res = await this.$http.get('/api/exam/getExamDetail',{
            exam_affair_id: localStorage.getItem('rsw_exam_affair_id'),
            examId:this.$route.query.examId||''
        })
        if(res && res.avatar_image){
            this.hasUpload = res.avatar_image.length
        }
        if(this.user)
        if(this.hasUpload < 5){
            this.initStream();
        }
        
        if(res.push_url){
            this.initPusher(res)
        }
        
    },
    beforeDestroy(){
        if(this.pushClient){
            this.pushClient.stopPush();
            // 关闭摄像头
            this.pushClient.stopCamera();
            // 关闭麦克风
            this.pushClient.stopMicrophone();
        }
        if(this.inteval){
            clearInterval(this.inteval)
            this.inteval = ''
        }
        this.screenVideoStream = ''
        this.avatarVideoStream = ''
    },
    methods:{
        async initStream(){
            try {
                // 请求获取屏幕的媒体流
                this.screenVideoStream = await navigator.mediaDevices.getDisplayMedia({
                    video: true
                });
                this.screenVideoStream.getVideoTracks()[0].onended = () => {
                    this.screenVideoStream = '';
                }
            } catch (err) {
                this.noGetBrowersAuth()
                console.error("屏幕Error: " + err);
            }

            try {
                this.avatarVideoStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                this.avatarVideoStream.getVideoTracks()[0].onended = () => {
                    this.avatarVideoStream = ''
                }
            } catch (err) {
                this.noGetBrowersAuth()
                console.error("摄像头Error: " + err);
            }
            this.startUpload()
        },
        noGetBrowersAuth(){
            this.$message.warning('未打开摄像头权限无法进入考试')
            this.$router.push('/myexams')
        },
        startUpload(){
            this.resultCount = 5*60+Math.floor(Math.random()*180)
            // this.resultCount = 5
            console.log(this.resultCount,'radom')
            this.inteval = setInterval(() => {
                this.count++;
                if(this.resultCount === this.count){
                    this.count = 0
                    this.resultCount = 5*60+Math.floor(Math.random()*180)
                    // this.resultCount = 5
                    console.log(this.resultCount,'radom')
                    this.getImgs()
                    if(this.hasUpload >= 5){
                        clearInterval(this.inteval);
                        this.inteval = '';
                        try {
                            this.screenVideoStream.getVideoTracks()[0].stop();
                            this.screenVideoStream = ''
                        } catch (error) {
                            console.log(error)
                        }
                        
                    }
                }
            },1000)
        },
        async getImgs(){
            if(this.avatarVideoStream&&this.screenVideoStream){
                const avatar_image = await this.videoToImg('avart')
                const browser_image = await this.videoToImg()
                this.$http.post('/api/exam/uploadExamImage',{
                    exam_affair_id: localStorage.getItem('rsw_exam_affair_id'),
                    examId:this.$route.query.examId||'',
                    avatar_image,
                    browser_image,
                }).then(() => {
                    this.hasUpload++;
                })
            }
        },
        async videoToImg(type='screen'){
            // 创建一个隐藏的 video 元素
            if(!this.videoEle){
                this.videoEle = document.createElement('video');
            }
            type==='screen' ? this.videoEle.srcObject = this.screenVideoStream:this.videoEle.srcObject = this.avatarVideoStream;

            // 设置 video 元素的尺寸与流匹配
            this.videoEle.width = window.screen.width;
            this.videoEle.height = window.screen.height;
            await this.videoEle.play()
            // 创建一个与视频同尺寸的 canvas 元素
            const canvas = document.createElement('canvas');
            canvas.width = this.videoEle.videoWidth;
            canvas.height = this.videoEle.videoHeight;

            // 在 canvas 上绘制视频的当前帧
            const context = canvas.getContext('2d');
            context.drawImage(this.videoEle, 0, 0, canvas.width, canvas.height);
            // 将 canvas 的内容转化为图像的 data URL，并设置为 img 元素的 src
            const base64Img = canvas.toDataURL('image/png');
            // 停止 video 的播放和捕获
            this.videoEle.pause();
            return base64Img;
        },
        async initPusher(res){
            // const res = await this.$http.get('/api/exam/getLiveUrl',{
            //     exam_affair_id: localStorage.getItem('rsw_exam_affair_id'),
            //     examId:this.$route.query.examId||''
            // })
            if(res.push_url){
                // 创建推流实例
                this.pushClient = AliRTSPusher.createClient();
                // 监听错误事件
                this.pushClient.on('error', (err) => { console.log(err.errorCode) });
                const videoEl = this.pushClient.setRenderView('videoContainer');
                // 如果希望将本地预览静音（推出去的流不会静音）
                videoEl.muted = true;
                this.pushClient.setVideoQuality('720p_1');
                // 打开摄像头
                await this.pushClient.startCamera();
                // 打开麦克风
                await this.pushClient.startMicrophone();
                this.pushClient.startPush(res.push_url);
            }
            
        },
    }
}
</script>
<style lang="scss" scoped>
.content{
    background: #f7f9fa;
    padding: 15px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
</style>
